// Página del cuestionario de evaluación de riesgo institucional.
// Se usa como componente de ruta en Config.js (/cuestionario).
//
// Re-exporta los catálogos y builders desde wizard/utils para que otros
// módulos (servicios, dashboards) puedan importarlos desde aquí sin
// necesidad de conocer la ubicación interna del wizard.

import UnidadesDeNegocio from '../wizard/UnidadesDeNegocio';

export {
    catalogoRiesgoInherente,
    catalogoMitigantes,
    buildRespuestasRiesgoInherente,
    buildRespuestasMitigantes,
    buildPayloadCuestionario,
} from '../wizard/utils';

export default function CuestionarioConfig() {
    return <UnidadesDeNegocio />;
}
